// @ is an alias to /src
import Loading from '@/components/Loading'

export default {
    components: { Loading },
    name: "textual",

    data() {
        return {
            obj: {},
            title: "",
            text: "",
            loading: true
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        if (this.$route.params.data == "como-funciona") {
            this.title = "Como funciona";
            this.text = this.obj.descricao;
        }
        if (this.$route.params.data == "regulamento") {
            this.title = "Regulamento";
            this.text = this.obj.regulamento;
        }
        if (
            this.$route.params.data != "como-funciona" &&
            this.$route.params.data != "regulamento"
        ) {
            this.title = "Não encontramos";
            this.text = "Desculpe não conhecemos essa página";
        }
        this.loading = false;
    },
    watch: {
        async $route(to, from) {
            this.loading = true;
            if (this.$route.params.data == "como-funciona") {
                this.title = "Como funciona";
                this.text = this.obj.descricao;
            }
            if (this.$route.params.data == "regulamento") {
                this.title = "Regulamento";
                this.text = this.obj.regulamento;
            }
            if (
                this.$route.params.data != "como-funciona" &&
                this.$route.params.data != "regulamento"
            ) {
                this.title = "Não encontramos";
                this.text = "Desculpe não conhecemos essa página";
            }
            this.loading = false;
        }
    }
};